// To get the ID, send "give_me_id" and the asset to the bot

import { isDev } from '@/shared/helpers';

const TEST_BOT_MEDIA_ID =
  'AgACAgIAAxkBAAJaM2g25_1KENKazw6AzgS7uiNbLt1jAAI88DEbDiK4SWxkAAEZmaH4ZgEAAwIAA3MAAzYE';

export const REFERRAL_SHARING_MEDIA_ID_EN = isDev('replyBot')
  ? TEST_BOT_MEDIA_ID
  : 'BAACAgIAAxkBC2tGdmgGBWgp9Rgb4LF3tWEXPRPnG1WuAAKEcgACe6IwSMKbfeJ_B6FQNgQ';
export const REFERRAL_SHARING_MEDIA_ID_RU = isDev('replyBot')
  ? TEST_BOT_MEDIA_ID
  : 'BAACAgIAAxkBC2tGdmgGBWgp9Rgb4LF3tWEXPRPnG1WuAAKEcgACe6IwSMKbfeJ_B6FQNgQ';

export const MEDIA_ID_REPLAY_BOT =
  'AgACAgIAAxkBAAJNemf2WAtr3QkSxxR8TDS-6BqG9DZtAAJJ9TEbafgoS5-uvo_1zw5oAQADAgADcwADNgQ';
